// ═══════════════════════════════════════════════════════════════
// CONSTANTS
// ═══════════════════════════════════════════════════════════════

/** Delay before initial API warmup after page load (1 second) */
const INITIAL_WARMUP_DELAY_MS = 1000;

/** Timeout for warmup API request (5 seconds) */
const WARMUP_TIMEOUT_MS = 5000;

/** Interval for checking idle monitoring (60 seconds / 1 minute) */
const IDLE_CHECK_INTERVAL_MS = 60000;

// ═══════════════════════════════════════════════════════════════
// SERVICE CLASS
// ═══════════════════════════════════════════════════════════════

class SmartWarmupService {
  constructor() {
    this.isWarmedUp = false;
    this.warmupInProgress = false;
    this.hasUserInteracted = false;
  }

  init() {
    // Set up user interaction detection
    this.setupUserInteractionDetection();

    // Initial warmup after a short delay to not block initial render
    setTimeout(() => {
      this.warmupAPI();
    }, INITIAL_WARMUP_DELAY_MS);
  }

  setupUserInteractionDetection() {
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    
    const handleUserInteraction = () => {
      if (!this.hasUserInteracted) {
        this.hasUserInteracted = true;
        // User is active, warm up the API for better UX
        this.warmupAPI();
        
        // Remove listeners after first interaction
        events.forEach(event => {
          document.removeEventListener(event, handleUserInteraction);
        });
      }
    };

    events.forEach(event => {
      document.addEventListener(event, handleUserInteraction, { passive: true });
    });
  }

  async warmupAPI() {
    if (this.isWarmedUp || this.warmupInProgress) {
      return;
    }

    this.warmupInProgress = true;
    const startTime = performance.now();

    try {
      // Create a warmup request that's likely to succeed without side effects
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), WARMUP_TIMEOUT_MS);

      clearTimeout(timeoutId);
      this.isWarmedUp = true;
      
      const endTime = performance.now();
    } catch (error) {
    } finally {
      this.warmupInProgress = false;
    }
  }

  isAPIWarmedUp() {
    return this.isWarmedUp;
  }
}

export const smartWarmupService = new SmartWarmupService();